import { connect } from "react-redux";

var ReadingActions = require("lib/actions/ReadingActions");
var LogRow = require('components/reading/logs/LogRow.js');
var CurrentUser = require("lib/account/CurrentUser");

var moment = require('moment');

@connect(
	null,
	(dispatch, props) => ({
		verifyLogs: () => {
			var logIDs = _.pluck(props.logs, "id");
			dispatch(ReadingActions.updateLogs({ ids: logIDs, update: { verified: true }}))
		}
	})
)
class WeekLogTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	verifyLogs(e) {
		$wr.nope(e)
		this.props.verifyLogs();
		window.wrNotifications.triggerDropDownNotification({
			title: "Verified!", text: "Thank you for reviewing!", icon: "ok-sign" });
	}

	render() {

		var sumMins = 0;
		var sumPages = 0;

		var logs = _.sortBy(this.props.logs, "log_date");
		var logRows = _.map(logs, function(log, index){
			sumMins = sumMins + log.minutes;
			sumPages = sumPages + log.pages;

			return (
				<LogRow log={ log } key={ log.id } />
			)
		}.bind(this));

		var startDate = moment(this.props.week);
		var weekStart = startDate.format('M/D');
		var weekEnd = startDate.add(6, "days").format('M/D');
		var weekSummary = "Week of " + weekStart + " - " + weekEnd;

		if (this.props.logsApproval) {
			var tableHeaders = (
				<tr className="outerTitles">
					<th className="dateTitle" colSpan="2"> 
						{ weekSummary }
					</th>
					<th className="minuteCell">
						<p className="infoContainer">{ sumMins || "-" }</p>
						<span className="sectionLabel">Total Minutes</span>
					</th>
					<th className="pageCell">
						<p className="infoContainer">{ sumPages || "-" }</p>
						<span className="sectionLabel">Total Pages</span>
					</th>
					<th className="" colSpan="1"> 
						<a className="btn buttonSuccess" href="#" onClick={ this.verifyLogs }>Approve</a>
					</th>
				</tr>	
			)
		} else {
			var tableHeaders= (
				<tr className="outerTitles">
					<th className="dateTitle" colSpan="2">
						{ weekSummary }
					</th>
					<th className="minutesTitle" colSpan="3"> { sum } Minutes </th>
				</tr>	
			)
		}

		return(
			<div>

				<table className="logTable">
					<tbody>
						{ tableHeaders }
						{ logRows }
					</tbody>
				</table>

			</div>

		)
	}
};

WeekLogTable.WrappedComponent.propTypes = StrictPropTypes({
	logs: PropTypes.array.isRequired,
	verifyLogs: PropTypes.func,
	logsApproval: PropTypes.bool,
	week: PropTypes.string,
});


module.exports = WeekLogTable;



// WEBPACK FOOTER //
// ./modules/components/reading/logs/WeekLogTable.js